import React from "react";
import PropTypes from "prop-types";
import { Button, Typography, makeStyles } from "@material-ui/core";
import { useCookieConsent } from "../../../privacy/CookieConsentContext";
import { toPrivacyEnhancedYoutubeUrl } from "../../../privacy/consent";

export default function ConsentProtectedEmbed({ src, title }) {
  const classes = useStyle();
  const { preferences, savePreferences } = useCookieConsent();

  if (preferences.externalMedia) {
    return (
      <iframe
        src={toPrivacyEnhancedYoutubeUrl(src)}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    );
  }

  return (
    <div className={classes.placeholder}>
      <Typography variant="h3">External video blocked</Typography>
      <Typography variant="body1">
        YouTube will load only after you allow external media. Google may then
        process usage data and use device storage under its own privacy terms.
      </Typography>
      <Button
        variant="outlined"
        onClick={() =>
          savePreferences({ ...preferences, externalMedia: true })
        }
      >
        Allow YouTube
      </Button>
    </div>
  );
}

ConsentProtectedEmbed.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const useStyle = makeStyles(({ breakpoints }) => ({
  placeholder: {
    width: "100%",
    minHeight: "32rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "1.5rem",
    padding: "3rem",
    color: "white",
    background: "#101b2c",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    textAlign: "center",
    "& h3": {
      fontSize: "2rem",
    },
    "& p": {
      maxWidth: "56rem",
      fontSize: "1.3rem",
      lineHeight: 1.5,
    },
    "& button": {
      minHeight: "4.4rem",
      color: "white",
      borderColor: "rgba(255, 255, 255, 0.65)",
    },
    [breakpoints.down("xs")]: {
      minHeight: "24rem",
      padding: "2rem",
    },
  },
}));
